var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5719 12.6821C13.7807 12.4849 14.0571 12.375 14.3443 12.375H44.4204C45.4382 12.375 45.9328 13.619 45.1928 14.3179L40.4281 18.8179C40.2193 19.0151 39.9429 19.125 39.6556 19.125H9.57961C8.56177 19.125 8.06718 17.881 8.80716 17.1821L13.5719 12.6821ZM13.5719 35.1821C13.7807 34.9849 14.0571 34.875 14.3443 34.875H44.4204C45.4382 34.875 45.9328 36.119 45.1928 36.8179L40.4281 41.3179C40.2193 41.5151 39.9429 41.625 39.6556 41.625H9.57961C8.56177 41.625 8.06718 40.381 8.80716 39.6821L13.5719 35.1821ZM8.62577 23.625C7.63985 23.625 7.13083 24.8031 7.80654 25.521L12.0418 30.021C12.2544 30.2469 12.5509 30.375 12.8611 30.375H43.1242C44.1101 30.375 44.6191 29.1969 43.9434 28.479L39.7081 23.979C39.4955 23.7531 39.1991 23.625 38.8889 23.625H8.62577Z",
    fill: "url(#paint0_linear_0_905)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_905",
    x1: 11.3341,
    y1: 6.94864,
    x2: 2.55671,
    y2: 37.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03E4BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2BED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.16153a13bea5e8e69d79ab8628b3f4cd.svg";
export { ForwardRef as ReactComponent };